export default {
  $schema: "http://json-schema.org/schema#",
  type: "object",
  properties: {
    errorCode: {
      anyOf: [{ type: "string" }, { type: null }]
    },
    errorMessage: {
      anyOf: [{ type: "string" }, { type: null }]
    },
    modelCode: { type: "string" },
    serviceSpecCode: { type: "string" },
    serviceItems: {
      type: "array",
      items: {
        type: "object"
      },
      minItems: 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/service-calculator-owner/data-schema.js